import { createContext } from "react"

const LoginContext = createContext({
    loggedInUser: null
})

export default LoginContext